module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['lr2-modal', {
      'hide': !_vm.show
    }]
  }, [_c('div', {
    staticClass: "lr-box"
  }, [_c('div', {
    staticClass: "lr-alert-msg",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "op-btn btn-md btn-block btn-danger login-btn",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("Close")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ac97a61", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ac97a61","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/Alert.vue
// module id = 2083
// module chunks = 0